export enum FileDropTypes {
    CSV = '.csv',
    EXCEL = '.xlsx',
    VIDEO = 'video/*',
    IMAGE = 'image/*',
    PDF = ".pdf",
    DOCX = ".docx",
    DOC = ".doc",
    ZIP = '.zip',
    XLSX = '.xlsx',
    JPG = '.jpg',
    PNG = '.png',
    JPEG = '.jpeg',
    MD = '.md',
    TEXT = '.txt'
}


export enum FileTypes {
    CSV = "CSV",
    EXCEL = "EXCEL",
    VIDEO = "VIDEO",
    IMAGE = "IMAGE",
    PDF = "PDF",
    DOCX = "DOCX",
    DOC = "DOC",
    XLSX = "XLSX",
    JPG = "JPG",
    PNG = "PNG"
}
